import { InputHTMLAttributes, forwardRef } from "react";

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  hint?: string;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ label, error, hint, className = "", ...rest }, ref) => (
    <div className="mb-4">
      {label && (
        <label className="block mb-2 text-sm font-medium text-[var(--color-ink)]">
          {label}
        </label>
      )}
      <input
        ref={ref}
        {...rest}
        className={`w-full px-4 py-3 border-2 ${
          error
            ? "border-[var(--color-accent)]"
            : "border-[var(--color-line)]"
        } bg-white text-[var(--color-ink)] focus:outline-none focus:border-[var(--color-accent-2)] ${className}`}
      />
      {error && (
        <p className="mt-1 text-sm text-[var(--color-accent)]">{error}</p>
      )}
      {hint && !error && (
        <p className="mt-1 text-sm text-[var(--color-muted)]">{hint}</p>
      )}
    </div>
  )
);
Input.displayName = "Input";
